module.exports = __webpack_public_path__ + "static/scale-model-of-fairlawn-kiwanis-community-center-in-akron-ohio-d0f2eeda42a55f2727d31ce18334edff.png";